import React from 'react'
import tools from './tools'
import Swiper from 'swiper/bundle'

import './global.less'

window.XBLOOM3 = {//存储所有的自定义全局变量
  Swiper: Swiper
}
const RENDERED_REACT_COMPONENT = new Map() //缓存react组件渲染函数,key是组件名

// Render React to Section page
const renderReactComponent = (apps = [], selectorName = '') => {
  const [MyReactComponent, _ReactDOM] = RENDERED_REACT_COMPONENT.get(selectorName) || []
  if (!MyReactComponent || !_ReactDOM) { return }

  for (let i = 0; i < apps.length; i++) {
    const app = apps[i]
    const props = tools.attrConverter(app.attributes)
    if (!props?.sectionId) {
      console.error('Fatal: Can not get "section-id" from', app)
      return
    }
    if (app.hasChildNodes()) {
      // 创建一个新的容器元素，并将其添加到现有的DOM元素中
      const reactContainer = document.createElement(`${selectorName}-react-root`)
      app.appendChild(reactContainer)
      _ReactDOM.render(<MyReactComponent {...props} />, reactContainer)
    } else {
      _ReactDOM.render(<MyReactComponent {...props} />, app)
    }

  }
}

// Define Xbloom Section React Component
window.XBLOOM3.DefineXbloomSectionReactComponent = (selectorName, MyReactComponent, _ReactDOM) => {
  if (!selectorName || !MyReactComponent || !_ReactDOM) { return }

  const apps = document.querySelectorAll(selectorName) ?? []
  if (!apps.length || RENDERED_REACT_COMPONENT.has(selectorName)) { return }

  RENDERED_REACT_COMPONENT.set(selectorName, [MyReactComponent, _ReactDOM])
  renderReactComponent(apps, selectorName)
}

window.XBLOOM3.IS_MOBILE = window.innerWidth <= 989
window.addEventListener('resize', function () {
  const IS_MOBILE = window.innerWidth < 990
  if (window.XBLOOM3.IS_MOBILE != IS_MOBILE) {
    window?.location?.reload?.()
  }
})

if (window?.Shopify?.designMode) {
  window.XBLOOM3.React = React
  window.XBLOOM3.RENDERED_REACT_COMPONENT = RENDERED_REACT_COMPONENT
  window.XBLOOM3.RenderReactComponent = renderReactComponent
}

